import { Snackbar, Alert } from "@mui/material";

// FEEDBACK ALERT
export default function FeedbackAlert({ show, timeout, message, onClose }: any) {
    return (
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={show} autoHideDuration={timeout} onClose={onClose}>
            <Alert variant="filled" severity="success" sx={{ color: 'white' }} onClose={onClose}>
                {message}
            </Alert>
        </Snackbar>
    )
}
